<template>
	<div class="health_inspection_edit">
		<van-form class="edit_form" v-if="detail && !isEditStatus">
			<van-cell title="上传时间" :value="uploadDateTime" />
		</van-form>
		<van-form class="edit_form">
			<preview-input title="医院名称" v-model="params.hospitalName" :is-preview="!isEditStatus"></preview-input>
			<preview-input title="报告类型" v-model="params.reportType" :is-preview="!isEditStatus"></preview-input>
			<van-field
				label="检查时间"
				v-model="params.inspectionDate"
				placeholder="请选择检查时间"
				readonly
				input-align="right"
				is-link
				@click="clickRecordDate"
			/>
		</van-form>
		<base-card :title="`报告描述${!isEditStatus? '': '（选填）'}`" size="small" class="mt-28">
			<template #action>
				<span class="pull-right desc_action">{{ params.reportDescription.length }}/500</span>
			</template>
			<form-input
				v-model="params.reportDescription"
				type="textarea"
				maxlength="500"
				placeholder="请输入"
				:rows="4"
				:readonly="!isEditStatus"
			></form-input>
		</base-card>
		<base-card :title="`${!isEditStatus? '': '上传'}报告图片`" header-border size="small" class="mt-28">
			<div class="mt-28">
				<base-upload v-model="params.inspectionUrls" :preview="!isEditStatus" />
			</div>
		</base-card>

		<foot-button>
			<div v-if="isEditStatus" class="w-full" @click="clickDisableSubmit">
				<van-button
					type="primary"
					:loading="loading"
					loading-text="加载中..."
					block
					:disabled="!allowSubmit"
					@click="clickSubmit"
				>
					确认上传
				</van-button>
			</div>
			<van-button v-else type="primary" block @click="clickToggleEdit"> 重新编辑 </van-button>
		</foot-button>

		<!--日期-->
		<van-popup v-model="datePickerVisible" position="bottom">
			<van-datetime-picker
				:value="params.inspectionDate || new Date()"
				type="date"
				title="请选择就诊时间"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="clickDatePickerConfirm"
				@cancel="datePickerVisible = false"
			/>
		</van-popup>
	</div>
</template>

<script>
	export default {
		name: 'healthInspectionEdit',
		data: () => ({
			loading: false,
			datePickerVisible: false,
			detail: null,
			isEditStatus: true,
			params: {
				hospitalName: '',
				reportType: '',
				inspectionDate: '',
				reportDescription: '',
				inspectionUrls: []
			}
		}),
		computed: {
			uploadDateTime () {
				if (this.detail) {
					return this.detail.gmtModified.substring(0, this.detail.gmtModified.length - 3)
				}
				return ''
			},
			allowSubmit () {
				return Object.entries(this.params).every(item => {
					if (item[0] === 'reportDescription') return true
					return !!(this.$utils.isArray(item[1]) ? item[1] : item[1].trim()).length
				})
			},
			minDate () {
				return this.$moment(new Date()).add('y',-20).toDate()
			},
			maxDate () {
				return new Date()
			}
		},
		created () {
			if (this.$route.query.id) {
				this.isEditStatus = false
				this.getDetail()
			}
		},
		methods: {
			async getDetail () {
				const res = await this.$api.patient.getInspectionDetail(this.$route.query.id)
				if (!res.code) {
					this.detail = res.data
					this.$utils.dataAssign(this.params, res.data, (key, val) => {
						if (key === 'inspectionUrls') val = val.map(item => ({ url: item }))
						if (key === 'reportDescription') val = val || '无'
						this.$set(this.params, key, val)
					})
				}
			},
			clickToggleEdit () {
				if (this.params.reportDescription === '无') {
					this.$set(this.params, 'reportDescription', '')
				}
				this.isEditStatus = true
			},
			clickRecordDate () {
				if (this.isEditStatus) {
					this.datePickerVisible = true
				}
			},
			clickDatePickerConfirm (value) {
				this.$set(this.params, 'inspectionDate', this.$moment(value).format('YYYY-MM-DD'))
				this.datePickerVisible = false
			},
			clickDisableSubmit () {
				if (!this.allowSubmit) this.$toast('请将内容填写完整')
			},
			clickSubmit () {
				this.loading = true
				const params = JSON.parse(JSON.stringify(this.params))
				params.inspectionUrls = params.inspectionUrls.map(item => item.url)
				params.hospitalName = params.hospitalName.trim()
				params.reportType = params.reportType.trim()
				let api = this.$api.patient.saveInspection
				if (this.detail) {
					params.id = this.detail.id
					api = this.$api.patient.updateInspection
				}
				api({
					patientId: this.$route.params.id,
					...params,
				}).then(res => {
					this.loading = false
					if (!res.code) {
						this.$toast('保存成功')
						if (this.$route.query.source === 'home') {
							this.$router.replace(`/health/inspection/list/${this.$route.params.id}`)
						} else {
							this.$router.go(-1)
						}
					}
				}).catch(() => this.loading = false)
			}
		}
	};
</script>

<style scoped lang="less">
	.health_inspection_edit {
		padding: 32px;
		.edit_form {
			border-radius: 16px;
			overflow: hidden;
			& + .edit_form { margin-top: 28px; }
		}
		.desc_action {
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			color: #BBBFC4;
		}
	}
</style>
<style lang="less">
	.cell_text {
		height: 42px;
		font-size: 30px;
		line-height: 42px;
	}
	.health_inspection_edit {
		padding: 32px;
		.edit_form {
			.van-cell {
				padding: 35px 28px;
				&__title {
					font-family: PingFangSC-Medium;
					.cell_text();
					font-weight: 500;
					color: #1F2329;
				}
				&__value {
					font-family: PingFangSC-Regular;
					font-size: 30px;
					font-weight: normal;
					color: #1F2329;
				}
				.van-field__control {
					font-family: PingFangSC-Regular;
					.cell_text();
				}
				.van-icon-arrow {
					.cell_text();
					color: #BBBFC4;
				}
			}
		}
	}
</style>
